import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import axios from 'axios';
import './UpdateNews.css';

function UpdateNews() {
    const { id } = useParams();
    const [file, setFile] = useState(null);
    const [name, setName] = useState('');
    const [position, setPosition] = useState('');
    const [email, setEmail] = useState('');
    const navigate = useNavigate();

    useEffect(() => {
        axios.get(`https://school-web-server-eight.vercel.app/getNews/${id}`)
            .then(result => {
                const { name, position, email } = result.data;
                setName(name);
                setPosition(position);
                setEmail(email);
            })
            .catch(err => console.log(err));
    }, [id]);

    const handleUpdate = async (e) => {
        e.preventDefault();
        try {
            const formData = new FormData();
            formData.append('name', name);
            formData.append('position', position);
            formData.append('email', email);
            if (file) {
                formData.append('file', file);
            }

            await axios.put(`https://school-web-server-eight.vercel.app/updateNews/${id}`, formData, {
                headers: { 'Content-Type': 'multipart/form-data' }
            });

            navigate('/login');
        } catch (error) {
            console.log(error);
        }
    };

    return (
        <div className='d-flex vh-100 bg-primary justify-content-center align-items-center'>
            <div className='w-50 bg-white rounded p-3'>
                <form onSubmit={handleUpdate}>
                    <h2>อัพเดทข้อมูลบุคลากร</h2>
                    <div className='mb-2'>
                        <label htmlFor="image">รูปภาพ</label>
                        <input type="file" className='form-control' onChange={e => setFile(e.target.files[0])} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="name">เรื่อง</label>
                        <input 
                            type="text" 
                            placeholder='อัพเดทหัวข้อประชาสัมพันธ์' 
                            className='form-control' 
                            value={name} 
                            onChange={(e) => {
                                setName(e.target.value);
                                e.target.setCustomValidity('');
                            }} 
                            onInvalid={(e) => e.target.setCustomValidity('กรุณากรอกชื่อ-สกุล')}
                            required 
                        />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="position">วันที่อัปโหลด</label>
                        <input type="text" placeholder='Enter Date' className='form-control' value={position} onChange={(e) => setPosition(e.target.value)} />
                    </div>
                    <div className='mb-2'>
                        <label htmlFor="link">ลิ้งค์อัปโหลดเอกสาร</label>
                        <input type="link" placeholder='Enter Email' className='form-control' value={email} onChange={(e) => setEmail(e.target.value)} />
                    </div>
                    <button className='updateinfo'>อัพเดทข้อมูล</button>
                    <button type="button" className='btn btn-back' onClick={() => navigate('/login')}>กลับหน้าหลัก</button>
                </form>
            </div>
        </div>
    );
}

export default UpdateNews;
